import { ComponentInterface } from "../types/component.interface"
import { ComponentProps } from "../types/componentProps.interface"
import { ComponentState } from "../types/componentState.enum"

export abstract class Component<T = {}, K = {}> {
    protected props: T & ComponentProps
    protected childComponents?: K
    protected element?: HTMLElement | null

    private _state: ComponentState

    constructor(props: T & ComponentProps, childComponents?: K) {
        this._state = ComponentState.INIT
        this.props = props
        this.childComponents = childComponents
        this.createComponent()
    }

    get state(): ComponentState {
        return this._state
    }

    set state(state: ComponentState) {
        this._state = state
    }

    protected createComponent() {
        this.element = document.getElementById(this.props.elementID)

        if (!this.element) {
            this.state = ComponentState.ERROR
        }
    }

    protected setColor(color?: string) {
        if (color) {
            this.element!.style.setProperty("color", color)
        }
    }

    protected setBackgroundColor(backgroundColor?: string) {
        if (backgroundColor) {
            this.element!.style.setProperty("background-color", backgroundColor)
        }
    }

    protected setHeight(height?: string) {
        if (height) {
            this.element!.style.setProperty("height", height)
        }
    }

    protected setWidth(width?: string) {
        if (width) {
            this.element!.style.setProperty("width", width)
        }
    }

    protected setBorder(border?: string) {
        if (border) {
            this.element!.style.setProperty("border", border)
        }
    }

    protected show(isVisible?: boolean) {
        if (isVisible) {
            this.element!.classList.remove("hidden")
            return
        }

        this.element!.classList.add("hidden")
    }

    private isComponent(component: any): component is ComponentInterface {
        return typeof component?.render === "function"
    }

    protected renderChildComponents() {
        if (!this.childComponents) return

        Object.values(this.childComponents).forEach((component) => {
            if (this.isComponent(component)) {
                component.render()
            }
        })
    }

    render(): void {
        this.renderChildComponents()
        this.state = ComponentState.RENDERED
    }
}
